/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { getFile, showModal } from "actions";
import GuidebarModalBody, {
  GuidebarModalTitle,
} from "components/header/GuidebarModal";

class GuideCard extends Component {
  state = {
    fileFetched: false,
    file: null,
    error: null,
  };

  componentDidMount = () => {
    if (this.props.contact.imagePath) {
      this.props.getFile(
        this.props.contact.imagePath,
        this.onBegin,
        this.onSuccess,
        this.onError
      );
    }
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onError = (err) => {
    this.setState({ error: err.message });
    this.props.onProcessEnd();
  };

  onSuccess = (file) => {
    this.props.onProcessEnd();
    this.setState({
      fileFetched: true,
      file: file,
    });
  };

  showDetail = (contact) => {
    this.props.showModal({
      modalType: "GuideDetail",
      modalTitle: <GuidebarModalTitle />,
      modalContent: <GuidebarModalBody id={contact.id} />,
      modalFooter: null,
      modalElementId: "guideModal",
    });
  };

  stopBubbleUp = (e) => {
    e.stopPropagation();
  };

  renderImage = () => {
    return (
      <div
        className="fordOrgCardProfilImg"
        style={{
          backgroundImage: `url(${this.state.file
            ? this.state.file.binary
            : "img/ford-gelisim-akademisi-avatar.svg"
            })`,
        }}
      ></div>
    );
  };

  renderEmail = () => {
    if (!this.props.contact.email) return null;
    return (
      <li>
        <a
          href={`mailto:${this.props.contact.email}`}
          onClick={(e) => this.stopBubbleUp(e)}
        >
          <span className="iconmford fo-icon-contact-mail"></span> {this.props.contact.email}
        </a>
      </li>
    );
  };

  renderCompanyPhone = () => {
    if (!this.props.contact.companyPhone) return null;
    return (
      <li>
        <a
          href={`tel:${this.props.contact.companyPhone}`}
          onClick={(e) => this.stopBubbleUp(e)}
        >
          <span className="iconmford fo-icon-phone"></span>{" "}
          {this.props.contact.companyPhone}
        </a>
      </li>
    );
  };

  render() {
    return (
      <div>
        <div
          className="fordGuideCardInner"
          onClick={() => this.showDetail(this.props.contact)}
          style={this.props.isManager ? { backgroundColor: "beige" } : null}
        >
          {/* <div className="fordOrgCardDownMenu">
            <a href="#" data-toggle="modal" data-target="#rehberDetayModal">
              <div
                className="tooltipTakvim"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Detay Gör"
              >
                <span className="iconmford fo-icon-expand-more"></span>
              </div>
            </a>
          </div> */}
          <div className="fordOrgCardProfilTextArea">
            {this.renderImage()}
            <div className="fordOrgCardName">{this.props.contact.fullname}</div>
            <div className="fordOrgCardTitle">
              {this.props.contact.position}
            </div>
            <div className="fordOrgCardTitle">
              {this.props.contact.department}
            </div>
            <ul className="fordOrgCardBottomLinks">
              {this.renderCompanyPhone()}
              {/* <li>
                <a href={`tel:${this.props.contact.companyPhone}`}>
                  <span className="icon-mobile-phone">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                    <span className="path4"></span>
                  </span>{" "}
                  mobil telefon datada yok!
                </a>
              </li> */}
              {this.renderEmail()}
              {/* <li>
                <a>
                  {this.props.contact.reportManager
                    ? this.props.getContact(this.props.contact.reportManager.id)
                    : null}
                </a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null, { getFile, showModal })(
  containsLongRunningProcess(GuideCard)
);
